import { ZodObject, ZodRawShape, ZodTypeAny, z } from 'zod';

export type DriverSchema = Record<
  string,
  {
    default:
      | string
      | number
      | boolean
      | null
      | undefined
      | string[]
      | number[]
      | Record<string, unknown>;
    type: string | string[] | Record<string, unknown>;
    is_required?: boolean;
  }
>;

export function buildConfigSchema(
  driverConfig: DriverSchema
): ZodObject<ZodRawShape> {
  const shape: ZodRawShape = {};

  for (const [key, meta] of Object.entries(driverConfig) as [
    string,
    { type: string; is_required?: boolean }
  ][]) {
    let fieldSchema: ZodTypeAny;

    switch (meta.type) {
      case 'string':
        fieldSchema = z.string();
        break;
      case 'number':
        fieldSchema = z.number();
        break;
      case 'bool':
        fieldSchema = z.boolean();
        break;
      default:
        fieldSchema = z.unknown();
    }

    if (!meta.is_required) {
      fieldSchema = fieldSchema.optional();
    }

    shape[key] = fieldSchema;
  }

  return z.object(shape);
}
